// extracted by mini-css-extract-plugin
export default {"app":"views_app__Ya-U0"};